import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import THEME from '../../styles/colors';
import { boxModelStyles } from '../../styles/css';

export const SelectWrapperDiv = styled.div`
  width: 100%;
  position: relative;
  ${boxModelStyles}
`;

export const DownArrowIcon = styled(FontAwesomeIcon)<{
  $isTall?: boolean;
  $isFocused?: boolean;
  $isDisabled?: boolean;
}>`
  color: ${({ $isFocused, $isDisabled, theme }) =>
    $isFocused
      ? theme.colors.school.primary
      : $isDisabled
      ? THEME.general.disabled
      : THEME.text.secondary};
  font-size: ${({ $isTall }) => ($isTall ? '16px' : '8px')};
  line-height: 16px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 12px;
  z-index: 10;
  cursor: default;
`;

export const StyledNativeLabel = styled.label<{
  $isFocused?: boolean;
  $isTall?: boolean;
  $isDisabled?: boolean;
}>`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  background-color: ${({ $isFocused }) =>
    $isFocused ? THEME.surface.tertiary : THEME.surface.primary};
  border: 1px solid
    ${({ $isFocused, $isDisabled, theme }) =>
      $isFocused
        ? theme.colors.school.primary
        : $isDisabled
        ? THEME.general.disabled
        : THEME.text.secondary};
  border-radius: 8px;
  align-items: center;
  cursor: text;
  padding: 0;
  height: ${({ $isTall }) => ($isTall ? '50px' : '32px')};
  position: relative;

  &:focus {
    background-color: ${({ $isFocused }) =>
      $isFocused ? THEME.surface.tertiary : THEME.surface.primary};
    border: 1px solid
      ${({ $isFocused, theme }) =>
        $isFocused ? theme.colors.school.primary : THEME.text.secondary};
  }
`;

export const StyledNativeSelect = styled.select<{
  $isPlaceholderVisible?: boolean;
  $isPlaceholder?: boolean;
  $isFocused?: boolean;

  $isTall?: boolean;
}>`
  font-size: 16px;
  font-weight: 400;
  line-height: ${({ $isTall }) => ($isTall ? '66px' : '30px')};
  letter-spacing: -0.4px;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: ${({ $isPlaceholder }) =>
    $isPlaceholder ? THEME.text.tertiary : THEME.text.primary};
  background-color: transparent;

  outline: none;
  border: none;

  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;

  display: block;
  overflow: hidden;
  position: relative;
  z-index: 1;

  white-space: nowrap;
  text-overflow: ellipsis;

  width: 100%;
  height: ${({ $isTall }) => ($isTall ? '50px' : '32px')};
  padding: 0 24px 0 16px;
  box-sizing: content-box;

  cursor: pointer;

  &:disabled {
    -webkit-text-fill-color: ${THEME.general.disabled};
    color: ${THEME.general.disabled};
    opacity: 0.75;
    cursor: not-allowed;
  }

  option {
    color: ${THEME.text.primary};
  }

  ${({ $isPlaceholder, $isPlaceholderVisible }) =>
    $isPlaceholder && !$isPlaceholderVisible
      ? 'color: transparent !important;'
      : ''};
`;

export const CaptionText = styled.div`
  color: ${THEME.text.secondary};
  font-size: 12px;
  line-height: 20px;
  padding-left: 16px;
`;

export const StyledFloatingLabel = styled.span<{
  $isPlaceholder?: boolean;
  $isDisabled?: boolean;
}>`
  position: absolute;
  bottom: ${({ $isPlaceholder }) => ($isPlaceholder ? '14px' : 0)};
  white-space: nowrap;

  border: 0;
  padding-left: 17px;

  font-size: 16px;
  line-height: 24px;

  cursor: text;
  pointer-events: none;
  user-select: none;

  color: ${({ $isDisabled }) =>
    $isDisabled ? THEME.text.disabled : THEME.text.secondary};

  transform: ${({ $isPlaceholder }) =>
    $isPlaceholder ? 'none' : 'translate3d(6%, -70%, 0) scale(0.70)'};
  transition: all 0.1s ease-in-out;
  transform-origin: left top;
  transition-duration: 0.1s;
`;
